import type { ReactNode } from 'react';

export default function Modal({
  title,
  children,
  onClose,
}: {
  title: string;
  children: ReactNode;
  onClose: () => void;
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-foreground-950/40"
        onClick={onClose}
        aria-label="关闭弹窗"
      />
      <div className="relative w-full max-w-xl rounded-lg border border-background-200 bg-background-50 shadow-lg">
        <div className="flex items-center justify-between px-5 py-4 border-b border-background-200">
          <h3 className="font-heading text-lg font-semibold text-foreground-950">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-100"
            aria-label="关闭"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
